<shared-ceops></shared-ceops>
<div>
	<div id="app-container"
		class="container-fluid home"
		role="main">
		<router-outlet></router-outlet>
	</div>
</div>
